export default {
  FERTILIZATION_ACTIVITY_TYPE: 'fertilizers',
  HARVEST_ACTIVITY_TYPE: 'harvests',
  PESTICIDE_APPLICATION_ACTIVITY_TYPE: 'insecticides',
  SEEDING_ACTIVITY_TYPE: 'plantations',
  SOIL_PREPARATION_ACTIVITY_TYPE: 'soil-preparation'
}
